import type { RouteRecordRaw } from "vue-router";

export const guidesRoutes: RouteRecordRaw[] = [
  {
    path: "/information",
    component: () => import("../../views/guides/Index.vue"),
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "information",
        component: () => import("../../views/guides/Home.vue"),
        meta: {
          pageHeader: "Guides",
        },
      },
      {
        path: ":dirs(.*)*",
        component: () => import("../../views/guides/Directory.vue"),
        name: "information-dir",
      },
    ],
  },
];
